import { render, staticRenderFns } from "./Headlines.ts.vue?vue&type=template&id=cfa5525a"
import script from "./Headlines.ts.vue?vue&type=script&lang=ts"
export * from "./Headlines.ts.vue?vue&type=script&lang=ts"
import style0 from "./Headlines.ts.vue?vue&type=style&index=0&id=cfa5525a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports